"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMenuEntityConfiguration = exports.DayOfWeek = void 0;
const casing_1 = require("./casing");
const common_1 = require("./common");
const filtering_1 = require("./filtering");
const lists_1 = require("./lists");
const params_1 = require("./params");
const relatives_1 = require("./relatives");
var hours_1 = require("./hours");
Object.defineProperty(exports, "DayOfWeek", { enumerable: true, get: function () { return hours_1.DayOfWeek; } });
class BaseMenuEntityConfiguration {
    config;
    constructor(config) {
        this.config = config;
    }
}
exports.BaseMenuEntityConfiguration = BaseMenuEntityConfiguration;
class MenuEntityConfiguration {
    _configuration;
    allConfigurations;
    constructor(baseConfiguration, allConfigurations) {
        this._configuration = baseConfiguration.config;
        const defaultValue = {};
        this.allConfigurations = Object.entries(allConfigurations).reduce((acc, [collection, baseConfig]) => ({
            ...acc,
            [collection]: baseConfig.config,
        }), defaultValue);
    }
    get defaults() {
        return (0, params_1.getDefaults)(this._configuration);
    }
    get casing() {
        return (0, casing_1.getCasing)(this._configuration);
    }
    get filters() {
        return (0, filtering_1.getFilters)(this._configuration);
    }
    get sortKeys() {
        return (0, filtering_1.getSortKeys)(this._configuration);
    }
    get parents() {
        return (0, relatives_1.getParents)(this._configuration, this.allConfigurations);
    }
    get relations() {
        return (0, relatives_1.getRelations)(this._configuration, this.allConfigurations);
    }
    get lists() {
        return (0, lists_1.getLists)(this._configuration.lists, this.allConfigurations);
    }
    get brandSyncedAttributes() {
        const { sellable, hasImage, hasDescription, hasHours, hasVariations, options, unlinkedOptions, consumable, } = this._configuration;
        const defaultBrandSyncedAttributes = [
            'name',
            'available',
            'availableAt',
            'displayName',
        ];
        if (sellable)
            defaultBrandSyncedAttributes.push('amount', 'taxRate', 'taxable');
        if (hasImage)
            defaultBrandSyncedAttributes.push('image');
        if (hasDescription)
            defaultBrandSyncedAttributes.push('description');
        if (hasHours)
            defaultBrandSyncedAttributes.push('hours');
        if (hasVariations)
            defaultBrandSyncedAttributes.push('variationGroups');
        if (consumable)
            defaultBrandSyncedAttributes.push('allergens', 'alcohol', 'glutenFree', 'vegetarian');
        return (0, common_1.removeDuplicates)([
            ...defaultBrandSyncedAttributes,
            ...Object.keys(options),
        ]).filter((property) => !unlinkedOptions.includes(property));
    }
    get configuration() {
        const { hasDescription, hasHours, hasImage, hasVariations, hasPos, sellable, consumable, options, unlinkedOptions, version, name, } = this._configuration;
        const { defaults, casing, filters, brandSyncedAttributes, lists, sortKeys, parents, relations, } = this;
        return {
            hasDescription,
            hasHours,
            hasImage,
            hasVariations,
            hasPos,
            sellable,
            consumable,
            options,
            unlinkedOptions,
            sortKeys,
            version,
            casing,
            defaults,
            filters,
            parents,
            relations,
            lists,
            name,
            brandSyncedAttributes,
        };
    }
}
exports.default = MenuEntityConfiguration;
//# sourceMappingURL=index.js.map